import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-alert-rhombus',
  templateUrl: './icon-alert-rhombus-component.html',
  styleUrl: './icon-alert-rhombus-component.scss',
  standalone: false,
})
export class IconAlertRhombusComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
